export default "__VITE_ASSET__2EheqdQWt4TZr0ndEQR38Q__"